var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":_vm.dismissCountDown,"dismissible":"","variant":_vm.$props.variant},on:{"dismissed":function($event){_vm.dismissCountDown = 0},"dismiss-count-down":_vm.countDownChanged}},[_vm._v("\n  "+_vm._s(_vm.$props.message)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }